import SkeletonBar from "../shared/SkeletonBar";
import { CardList, CARD_ITEM_PADDING_CLASS } from "../shared/ContentList";

export function CampaignListCardSkeleton() {
    return (
        <article
            className={`campaign-box w-full min-w-0 max-w-full overflow-hidden ${CARD_ITEM_PADDING_CLASS}`}
            aria-hidden
        >
            <div className="flex min-w-0 items-center justify-between gap-3">
                <div className="min-w-0 flex-1 space-y-2">
                    <SkeletonBar className="h-5 w-48 max-w-full" />
                    <div className="flex flex-wrap items-center gap-2">
                        <SkeletonBar className="h-4 w-20" />
                        <SkeletonBar className="h-4 w-24" />
                        <SkeletonBar className="h-4 w-16" />
                    </div>
                </div>
                <SkeletonBar className="h-4 w-4 shrink-0 rounded-sm" />
            </div>
        </article>
    );
}

export default function CampaignListSkeletons({
    count = 5,
    className = "",
    label = "Loading campaigns",
}) {
    return (
        <CardList
            className={className}
            aria-busy="true"
            aria-label={label}
            role="status"
        >
            <span className="sr-only">{label}</span>
            {Array.from({ length: count }, (_, index) => (
                <CampaignListCardSkeleton key={index} />
            ))}
        </CardList>
    );
}
